//C:\ViYash\XPRSuvey\XPRSuvey-App\src\Components\HR\HRLayout\CompanyLayout.jsx

import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./sidebar";

const CompanyLayout = () => {
    return (
        <div className="flex h-screen w-full overflow-hidden bg-gray-50">
            <Sidebar />
            <div className="flex flex-1 flex-col overflow-y-auto">
                <Header />
                <main className="flex-1 px-2 py-2">
                    <Outlet />
                </main>
                <Footer />
            </div>
        </div>
    );
};

export default CompanyLayout;